import * as T from 'source/interfaces';

export const storeGet: T.TParamsGetStore[] = [
  {
    bk_number: '001',
    name: 'Condominio West Corp',
    digital_name: 'West Corp',
    status: 'aberto',
    cost_center: 'loja',
    cron: [
      {
        id: 1,
        weekday: 1,
        open: '10:00',
        close: '22:00',
      },
      {
        id: 2,
        weekday: 2,
        open: '15:00',
        close: '22:00',
      },
      {
        id: 3,
        weekday: 3,
        open: '12:00',
        close: '22:00',
      },
      {
        id: 4,
        weekday: 4,
        open: '10:00',
        close: '22:00',
      },
      {
        id: 5,
        weekday: 5,
        open: '10:00',
        close: '22:00',
      },
      {
        id: 6,
        weekday: 6,
        open: '15:00',
        close: '22:00',
      },
      {
        id: 7,
        weekday: 7,
        open: '15:00',
        close: '22:00',
      },
    ],
    number: '1',
    manager: '',
    location: {
      latitude: -23.5389941,
      longitude: -46.868038,
      distance: 0.6,
      restaurant: 0,
    },
    address: {
      zipcode: '05145-001',
      country: 'Brasil',
      state: 'SP',
      city: 'São Paulo',
      street: 'Av. Raimundo Pereira de Magalhães,1465 Jardim Iris',
      floor: 0,
      number: '001',
      complement: 'Loja',
      restaurant: '001',
    },
  },
  {
    bk_number: '002',
    name: 'Parque Shopping Barueri',
    digital_name: 'Shopping Barueri',
    status: 'aberto',
    cost_center: 'loja',
    cron: [
      {
        id: 1,
        weekday: 1,
        open: '10:00',
        close: '22:00',
      },
      {
        id: 2,
        weekday: 2,
        open: '15:00',
        close: '22:00',
      },
      {
        id: 3,
        weekday: 3,
        open: '12:00',
        close: '22:00',
      },
      {
        id: 4,
        weekday: 4,
        open: '10:00',
        close: '22:00',
      },
      {
        id: 5,
        weekday: 5,
        open: '10:00',
        close: '22:00',
      },
      {
        id: 6,
        weekday: 6,
        open: '15:00',
        close: '22:00',
      },
      {
        id: 7,
        weekday: 7,
        open: '15:00',
        close: '22:00',
      },
    ],
    number: '1',
    manager: '',
    location: {
      latitude: -23.5566245,
      longitude: -46.8633252,
    },
    address: {
      zipcode: '05145-001',
      country: 'Brasil',
      state: 'SP',
      city: 'São Paulo',
      street: 'Av. Raimundo Pereira de Magalhães,1465 Jardim Iris',
      floor: 0,
      number: '001',
      complement: 'Loja',
      restaurant: '001',
    },
  },
  {
    bk_number: '003',
    name: 'Shopping Boulevard Tatuapé',
    digital_name: 'Shopping Boulevard Tatuapé',
    status: 'aberto',
    cost_center: 'loja',
    cron: [
      {
        id: 1,
        weekday: 1,
        open: '10:00',
        close: '22:00',
      },
      {
        id: 2,
        weekday: 2,
        open: '15:00',
        close: '22:00',
      },
      {
        id: 3,
        weekday: 3,
        open: '12:00',
        close: '22:00',
      },
      {
        id: 4,
        weekday: 4,
        open: '10:00',
        close: '22:00',
      },
      {
        id: 5,
        weekday: 5,
        open: '10:00',
        close: '22:00',
      },
      {
        id: 6,
        weekday: 6,
        open: '15:00',
        close: '22:00',
      },
      {
        id: 7,
        weekday: 7,
        open: '15:00',
        close: '22:00',
      },
    ],
    number: '1',
    manager: '',
    location: { latitude: -23.538955, longitude: -46.576503 },
    address: {
      zipcode: '05145-001',
      country: 'Brasil',
      state: 'SP',
      city: 'São Paulo',
      street: 'Av. Raimundo Pereira de Magalhães,1465 Jardim Iris',
      floor: 0,
      number: '001',
      complement: 'Loja',
      restaurant: '001',
    },
  },
  {
    bk_number: '004',
    name: 'Shopping Cidade São Paulo',
    digital_name: 'Shopping Cidade São Paulo',
    status: 'aberto',
    cost_center: 'loja',
    cron: [
      {
        id: 1,
        weekday: 1,
        open: '10:00',
        close: '22:00',
      },
      {
        id: 2,
        weekday: 2,
        open: '15:00',
        close: '22:00',
      },
      {
        id: 3,
        weekday: 3,
        open: '12:00',
        close: '22:00',
      },
      {
        id: 4,
        weekday: 4,
        open: '10:00',
        close: '22:00',
      },
      {
        id: 5,
        weekday: 5,
        open: '10:00',
        close: '22:00',
      },
      {
        id: 6,
        weekday: 6,
        open: '15:00',
        close: '22:00',
      },
      {
        id: 7,
        weekday: 7,
        open: '15:00',
        close: '22:00',
      },
    ],
    number: '1',
    manager: '',
    location: { latitude: -23.563522, longitude: -46.6526872 },
    address: {
      zipcode: '05145-001',
      country: 'Brasil',
      state: 'SP',
      city: 'São Paulo',
      street: 'Av. Raimundo Pereira de Magalhães,1465 Jardim Iris',
      floor: 0,
      number: '001',
      complement: 'Loja',
      restaurant: '001',
    },
  },
];
